import CryptoJS from "crypto-js";
import * as XLSX from 'xlsx';
import logo from "../../../assets/logo_login.jpeg"
import { loadingOverlay } from "vuetify-more-component";

export default {
  components: {
    logo,
  },
  data() {
    return {
      logo,
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu2: false,
      search: "",
      loading: false,
      headers: [
        {
          text: "CUI/DPI",
          align: "center",
          sortable: true,
          value: "cui"
        },
        {
          text: "Nombre",
          align: "center",
          sortable: true,
          value: "nombre",
        },
        {
          text: "NIT",
          align: "center",
          sortable: true,
          value: "nit",
        },
        {
          text: "Período Presentado",
          value: "fecha_presentacion"
        },
        {
          text: "Dia de declaración",
          align: "center",
          sortable: true,
          value: "fecha_seguimiento"
        },
        {
          text: "Regimen",
          align: "center",
          sortable: true,
          value: "regimen"
        },
        {
          text: "Total facturas ventas Q.",
          align: "end",
          sortable: true,
          value: "total_fatura"
        },
        {
          text: "Total Retenciones Q.",
          align: "end",
          sortable: true,
          value: "total_retencion"
        },
        {
          text: "Pago de impuesto Q.",
          align: "center",
          sortable: true,
          with: 900,
          value: "pago"
        },
        {
          text: "Facturas",
          align: "center",
          sortable: true,
          value: "facturas"
        },
        {
          text: "Retenciones",
          align: "center",
          sortable: true,
          value: "retenciones"
        },
        {
          text: "Estado de la declaración",
          align: "center",
          sortable: true,
          value: "estado"
        },
        {
          text: "Tipo suscripción",
          align: "center",
          sortable: true,
          value: "abreviatura"
        },
        {
          text: "Colaborador TIC asignado",
          align: "center",
          sortable: true,
          value: "asignado"
        },
        {
          text: "Pago realizado",
          align: "center",
          sortable: true,
          value: "pago_realizado"
        },
        {
          text: "Fact. y Ret.",
          align: "center",
          sortable: true,
          value: "resumen"
        },
        {
          text: "Eliminar Seguimiento",
          align: "center",
          sortable: false,
          value: "accion"
        },
      ],
      presentaciones: [],
      fecha: {
        fecha: "",
        fecha_usuario: "",
      },
      item_aux: '',
      dialog: false,
      impuesto_sin_retenciones: 0,
      text: "Copiar",
      copyText: '',
      facturas: [],
      retenciones: [],
      usuario: -1,
      dialogCancelarSeguimiento: false,
      mes_declaracion: "",
      anio: "",
      mes: {
        1: 'enero',
        2: 'febrero',
        3: 'marzo',
        4: 'abril',
        5: 'mayo',
        6: 'junio',
        7: 'julio',
        8: 'agosto',
        9: 'septiembre',
        10: 'octubre',
        11: 'noviembre',
        12: 'diciembre',
      },
      log_roles: [],
      dialogrosIVA: false,
      dialogrosISR: false,
      meses: {
        1: "Enero",
        2: "Febrero",
        3: "Marzo",
        4: "Abril",
        5: "Mayo",
        6: "Junio",
        7: "Julio",
        8: "Agosto",
        9: "Septiembre",
        10: "Octubre",
        11: "Noviembre",
        12: "Diciembre"
      },
      items_formulario: [],
      items_formulario9: [
        {
          titulo_formulario: 'Facturas (Incluir las anuladas)',
          emitidas: 0,
          recibidas: 0,
        },
        {
          titulo_formulario: 'Factura y Declaración Única Centroamericana FYDUCA',
          emitidas: 0,
          recibidas: 0,
        },
        {
          titulo_formulario: 'Constancias de exención',
          emitidas: 0,
          recibidas: 0,
        },
        {
          titulo_formulario: 'Constancias de adquisición de insumos de producción local',
          emitidas: 0,
          recibidas: 0,
        },
        {
          titulo_formulario: 'Constancias de retención de IVA',
          emitidas: 0,
          recibidas: 0,
        },
        {
          titulo_formulario: 'Facturas especiales',
          emitidas: 0,
          recibidas: 0,
        },
        {
          titulo_formulario: 'Notas de crédito',
          emitidas: 0,
          recibidas: 0,
        },
        {
          titulo_formulario: 'Notas de débito',
          emitidas: 0,
          recibidas: 0,
        }
      ],
    }
  },
  async created() {
    console.log("seguimiento_declaracion.0");
    let informacion_incriptada = sessionStorage.getItem('dsgfv/&#$%sdksdn..sd5454sd-todo');
    if (informacion_incriptada != null) {
      let key_pass = atob(sessionStorage.getItem('dsgfv/&#$%sdksdn..sd5454sd-tic'))
      let bytes = CryptoJS.AES.decrypt(informacion_incriptada, key_pass + "byTeamT0d0T1c");
      let informacion_desincriptada = bytes.toString(CryptoJS.enc.Utf8);
      let r = JSON.parse(informacion_desincriptada)
      this.log_roles = r.rol;
      this.usuario = r.usuario[0]
    }
    this.getTipo_registro_listado_activos();
  },
  computed: {
    totalRetenciones() {
      console.log("totalRetenciones");
      let total = 0
      this.retenciones.filter(x => {
        if (x.anulado != 1) {
          total = parseFloat(total) + parseFloat(x.total_retencion);
        }
      });
      let dollarUSLocale = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });
      return dollarUSLocale.format(parseFloat(total).toFixed(2));
    },
    totalFacturas() {
      console.log("totalFacturas");
      let total = 0
      this.facturas.filter(x => {
        if (x.anulado != 1) {
          total = parseFloat(total) + parseFloat(x.monto);
        }
      });
      let dollarUSLocale = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });
      this.impuesto_sin_retenciones = total * 0.05
      this.impuesto_sin_retenciones = dollarUSLocale.format(parseFloat(this.impuesto_sin_retenciones).toFixed(2));
      return dollarUSLocale.format(parseFloat(total).toFixed(2));
    },
  },
  methods: {
    async getTipo_registro_listado_activos() {
      console.log("getTipo_registro_listado_activos");
      try {
        let rdata = await this.$store.state.services.administradorService.getTipo_registro_listado_activos();
        console.log("getTipo_registro_listado_activos.rdata:", rdata);
        
        let r = await this.$store.state.services.administradorService.getTipo_registro_listado_activos();
        console.log("getTipo_registro_listado_activos.r:", r);
        r.data.data.filter(item => { item.base = 0, item.creditos = 0 });
        this.items_formulario = r.data.data;
        this.items_formulario.sort((a, b) => (a.orden > b.orden) ? 1 : -1);
        this.items_formulario.push({ titulo_formulario: "Sumatoria de las columnas BASE y CRÉDITOS ", id: -2, orden: "-1", base: 0, creditos: 0 });
      } catch (error) {
        console.log(error);
        this.$toast.error("No es posible obtener el listado de registros activos")
      }
    },
    convertirnumero(numero) {
      // console.log("convertirnumero:" + numero);
      let dollarUSLocale = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });
      // console.log('numero_format:' + dollarUSLocale.format(Math.abs(parseFloat(numero).toFixed(2))));
      return dollarUSLocale.format(Math.abs(parseFloat(numero).toFixed(2)));
    },
    exportarExcel() {
      console.log("exportarExcel");
      let info = [];
      this.presentaciones.forEach(element => {
        let data = {
          CUI: element.cui,
          NOMBRE: element.nombre,
          NIT: element.nit,
          PASSWORD_SAT: element.password_sat,
          PERIODO_PRESENTADO: (element.fecha_presentacion != null ? (this.mes === parseInt(element.fecha_presentacion.split("-")[1])) ? this.mes[12] +
            " " +
            (parseInt(element.fecha_presentacion.split("-")[0])) :
            this.mes[parseInt(element.fecha_presentacion.split("-")[1])] + " " +
            element.fecha_presentacion.split("-")[0] : ''),
          DIA_DECLARACION: element.fecha_seguimiento,
          REGIMEN: element.regimen,
          TOTAL_FACTURA: element.total_factura,
          TOTAL_RETENCIONES: element.total_retencion,
          PAGO_IMPUESTO: element.pago,
          FACTURAS: element.facturas,
          RETENCIONES: element.retenciones,
          REGISTRO_COLABORADOR: element.asignado_id,
          NOMBRE_COLABORADOR: element.asignado,
          PAGO_REALIZADO: element.pago_realizado,
        }
        info.push(data);
      });
      let data = XLSX.utils.json_to_sheet(info)
      const workbook = XLSX.utils.book_new()
      const filename = 'seguimiento_' + this.date;
      XLSX.utils.book_append_sheet(workbook, data, filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`)
    },
    async copyCode(tipo, item) {
      console.log("copyCode");
      switch (tipo) {
        case 1:
          await navigator.clipboard.writeText(this.totalFacturas.replace(",", ""));
          this.copyText = "Copiado"
          break;
        case 2:
          await navigator.clipboard.writeText(this.retenciones.replace(",", ""));
          this.copyText = "Copiado"
          break;
        case 3:
          await navigator.clipboard.writeText(item);
          this.copyText = "Copiado"
          break;
        default:
          break;
      }
    },
    async listadoSeguimiento() {
      console.log("listadoSeguimiento");
      this.fecha.fecha_usuario = this.date.split("-").reverse().join("/");
      this.fecha.fecha = this.fecha.fecha_usuario;
      try {
        this.loading = true;
        let r = await this.$store.state.services.presentacionService.postSeguimiento(this.fecha);
        console.log("listadoSeguimiento.r:", r);
        let num = 0;
        r.data.data.forEach(element => {
          element.num = num++;
          element.loading = false;
        });
        this.presentaciones = r.data.data;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$toast.error(
          "Ocurrió un error al obtener los datos de los seguimientos"
        );
      }
    },
    async verDialog(item, opc) {
      console.log("verDialog:", item, opc);
      this.loading = true;
      item.loading = true;
      if (item.estado != 'No Iniciada') {
        this.item_aux = item;
        console.log("item_aux:", this.item_aux);

        console.log("this.items_formulario9", this.items_formulario9);
        this.items_formulario9[0].emitidas = this.item_aux.total_facturas_emitidas;
        this.items_formulario9[0].recibidas = this.item_aux.total_facturas_recibidas;
        this.items_formulario9[2].recibidas = this.item_aux.total_facturas_recibidas_CIV;
        this.items_formulario9[4].recibidas = this.item_aux.total_documentos_retenciones;
        this.items_formulario9[6].emitidas = this.item_aux.total_NC_ventas;
        this.items_formulario9[6].recibidas = this.item_aux.total_NC_compras;
        this.items_formulario9[7].emitidas = this.item_aux.total_ND_ventas;
        this.items_formulario9[7].recibidas = this.item_aux.total_ND_compras;

        let fecha_solicitada = item.fecha_presentacion;
        fecha_solicitada = fecha_solicitada.split("-");
        let mes = parseInt(fecha_solicitada[1]);
        let mes_declaracion = mes;
        let anio = parseInt(fecha_solicitada[0])
        this.mes_declaracion = mes_declaracion;
        this.anio = anio;
        await this.getPresentarFacturas(item);
        console.log("************************");
        await this.getPresentarRetenciones(item);
        switch (item.regimen_id) {
          case 1:
            this.dialog = true;
            break;
          case 2:
            if (opc === 1) {
              this.dialogrosISR = true;
            } else if (opc === 2) {
              console.log("opc:" + opc);
              this.dialogrosIVA = true;
              let base_acumlada = 0;
              let creditos_acumulados = 0;
              for (const key in item.ros) {
                const CFOL = item.ros[key];
                if (CFOL.tipo_registro_id != 9) {
                  let item_formulario = this.items_formulario.find(
                    (item) => item.id === CFOL.tipo_registro_id
                  );
                  item_formulario.base = CFOL.monto_sin_iva;
                  item_formulario.creditos = CFOL.monto_iva;
                  base_acumlada += parseFloat(CFOL.monto_sin_iva);
                  creditos_acumulados += parseFloat(CFOL.monto_iva);
                }
              }
              this.items_formulario[this.items_formulario.length - 1].base = base_acumlada;
              this.items_formulario[this.items_formulario.length - 1].creditos = creditos_acumulados;
              console.log("items_formulario:", this.items_formulario);
            }
            break;
        }
        this.loading = false;
        item.loading = false;
      } else {
        this.$toast.info("Estado de declaración no iniciada")
        item.loading = false;
        this.loading = false;
      }
    },
    deleteSeguimiento(item) {
      console.log("deleteSeguimiento");
      item.loading = true;
      this.item_aux = item;
      this.dialogCancelarSeguimiento = true;
      item.loading = false;
    },
    async deleteSeguimientoConfirmar() {
      console.log("deleteSeguimientoConfirmar");
      try {
        this.loading = true;
        let r =
          await this.$store.state.services.presentacionService.deleteSeguimiento({ id: this.item_aux.id });
        this.$toast.success("Seguimiento eliminado satisfactoriamente")
        this.item_aux = '';
        this.dialogCancelarSeguimiento = false;
        this.loading = false;
        this.listadoSeguimiento();
      } catch (error) {
        this.dialogCancelarSeguimiento = false;
        this.loading = false;
        this.$toast.error(
          "Ocurrió un error al obtener los datos de los seguimientos"
        );
      }
    },
    reset() {
      console.log("reset");
      this.copyText = this.text
    },
    async getPresentarFacturas(item) {
      console.log("getPresentarFacturas");
      console.log("item:", item);
      try {
        let r = await this.$store.state.services.presentacionService.getPresentarFacturas(item.id);
        console.log("getPresentarFacturas.r:", r);
        this.facturas = r.data.data;
      } catch (error) {
        console.log(error);
        this.$toast.error(
          "Ocurrió un error al obtener los datos de las declaraciones"
        );
      }
    },
    async getPresentarRetenciones(item) {
      console.log("getPresentarRetenciones");
      try {
        let r = await this.$store.state.services.presentacionService.getPresentarRetenciones(item.id);
        console.log("getPresentarRetenciones.r:", r);
        this.retenciones = r.data.data;
      } catch (error) {
        this.$toast.error(
          "Ocurrió un error al obtener los datos de las declaraciones "
        );
      }
    },
  },
}